module.exports = __webpack_public_path__ + "static/media/get_involved_worm.dba165fd.svg";